var _path, _line, _line2, _line3, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthdayCakeOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 8.61929 3.11929 7.5 4.5 7.5H11.5C12.8807 7.5 14 8.61929 14 10V16.5H2V10Z",
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 16.5,
    x2: 15.5,
    y2: 16.5,
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 7,
    x2: 6,
    y2: 5,
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 10,
    y2: 5,
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5C7 4.11476 6.85031 4.48809 6.67574 4.69864C6.50923 4.89948 6.2817 5 6 5C5.7183 5 5.49077 4.89948 5.32426 4.69864C5.14969 4.48809 5 4.11476 5 3.5C5 2.94608 5.31664 2.16908 5.69108 1.46771C5.79692 1.26945 5.90298 1.08515 6 0.923732C6.09702 1.08515 6.20308 1.26945 6.30892 1.46771C6.68336 2.16908 7 2.94608 7 3.5Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.5C11 4.11476 10.8503 4.48809 10.6757 4.69864C10.5092 4.89948 10.2817 5 10 5C9.7183 5 9.49077 4.89948 9.32426 4.69864C9.14969 4.48809 9 4.11476 9 3.5C9 2.94608 9.31664 2.16908 9.69108 1.46771C9.79692 1.26945 9.90298 1.08515 10 0.923732C10.097 1.08515 10.2031 1.26945 10.3089 1.46771C10.6834 2.16908 11 2.94608 11 3.5Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11C6 12.1046 5.10457 13 4 13C2.89543 13 2 12.1046 2 11",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11C10 12.1046 9.10457 13 8 13C6.89543 13 6 12.1046 6 11",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayCakeOutlined);
export default __webpack_public_path__ + "static/media/birthday-cake-outlined.a4662bd21a74d356c92b58da805d4ebe.svg";
export { ForwardRef as ReactComponent };